// extracted by mini-css-extract-plugin
export var attribution = "_8e-4";
export var authorName = "_8e-5";
export var quote = "_8e-3";
export var testimonial = "_8e-2";
export var trustedBy = "_8e-0";
export var trustedByLabel = "_8e-1";